export const GET_SMS_CAMPAIGNS_REQUEST = 'GET_SMS_CAMPAIGNS_REQUEST';
export const GET_SMS_CAMPAIGNS_SUCCESS = 'GET_SMS_CAMPAIGNS_SUCCESS';
export const GET_SMS_CAMPAIGNS_FAILURE = 'GET_SMS_CAMPAIGNS_FAILURE';

export const DELETE_SMS_CAMPAIGN_REQUEST = 'DELETE_SMS_CAMPAIGN_REQUEST';
export const DELETE_SMS_CAMPAIGN_SUCCESS = 'DELETE_SMS_CAMPAIGN_SUCCESS';
export const DELETE_SMS_CAMPAIGN_FAILURE = 'DELETE_SMS_CAMPAIGN_FAILURE';

export const PUT_SMS_CAMPAIGN_REQUEST = 'PUT_SMS_CAMPAIGN_REQUEST';
export const PUT_SMS_CAMPAIGN_SUCCESS = 'PUT_SMS_CAMPAIGN_SUCCESS';
export const PUT_SMS_CAMPAIGN_FAILURE = 'PUT_SMS_CAMPAIGN_FAILURE';
